import {useEffect} from 'react';

import {useNavigateToOtherLangOfPage} from '@/shared/hooks/useNavigateToOtherLangOfPage';
import {
  isAppLanguage,
  resolveSupportedAppLanguage,
} from '@/shared/lib/appLanguageSupports';
import {
  getAutoRedirectedToBetterLanguage,
  getDecidedLanguagesHash,
  setAutoRedirectedToBetterLanguage,
} from '@/shared/lib/localStorage/i18n/autoRedirectedToBetterLanguage';
import {getManualAndAppLanguage} from '@/shared/lib/localStorage/i18n/manualAndAppLanguage';
import {getLanguage} from '@/shared/services/i18n';

export function useAutoRedirectToBetterOrManualLanguage() {
  const navigateToOtherLangOfPage = useNavigateToOtherLangOfPage();

  useEffect(() => {
    const currLanguage = getLanguage();
    const manualLanguage = getManualAndAppLanguage();
    if (
      manualLanguage &&
      isAppLanguage(manualLanguage) &&
      manualLanguage !== currLanguage
    ) {
      navigateToOtherLangOfPage(manualLanguage);
      return;
    }

    const prevRedirected = getAutoRedirectedToBetterLanguage();
    if (prevRedirected) {
      const decidedLanguagesHash = getDecidedLanguagesHash(navigator.languages);
      if (decidedLanguagesHash === prevRedirected.decidedLanguagesHash) {
        return;
      }
    }

    const detectedLanguage = resolveSupportedAppLanguage(navigator.languages);

    if (!detectedLanguage || currLanguage === detectedLanguage) {
      return;
    }

    setAutoRedirectedToBetterLanguage({
      fromLang: currLanguage,
      toLang: detectedLanguage,
      decidedLanguagesHash: getDecidedLanguagesHash(navigator.languages),
    });

    navigateToOtherLangOfPage(detectedLanguage);
  }, [navigateToOtherLangOfPage]);
}
